import Path from '@leverege/path';
import { Attributes } from '@leverege/ui-attributes';
import { Types } from "../constants/index.js";
export default {
  id: 'fota.ItemUpdateHook.HandleDeviceGroupFirmwareUpgradeOptions',
  objectType: Types.deviceGroup,
  hook: (patch, {
    target
  }) => {
    const affectOptions = patch.filter(({
      path
    }) => path.startsWith('firmwareUpgradeOptions/'));
    if (affectOptions.length === 0) {
      return patch;
    }
    const nPatch = patch.filter(({
      path
    }) => !path.startsWith('firmwareUpgradeOptions/'));
    let options = Attributes.get('firmwareUpgradeOptions', Types.deviceGroup, target?.data);
    for (let i = 0; i < affectOptions.length; i++) {
      const toApply = affectOptions[i];
      options = Path.copy(toApply.path.slice(23), options, toApply.value);
    }
    nPatch.push({
      path: 'firmwareUpgradeOptions',
      value: options
    });
    return nPatch;
  }
};